import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import CampaignReport from "../components/CampaignReport";
import CampaignAnalysis from "../components/CampaignAnalysis";
import Dashboard from "../components/Dashboard";
import Segments from "../components/Segments";
import DonorReport from "../components/DonorReport";
import DonorAnalysis from "../components/DonorAnalysis";
import { authGuard } from "../auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/CampaignReport",
      name: "CampaignReport",
      component: CampaignReport,
      beforeEnter: authGuard
    },
    {
      path: "/CampaignAnalysis",
      name: "CampaignAnalysis",
      component: CampaignAnalysis,
      beforeEnter: authGuard
    },
    {
      path: "/Dashboard",
      name: "Dashboard",
      component: Dashboard,
      beforeEnter: authGuard
    },
    {
      path: "/Segments",
      name: "Segments",
      component: Segments,
      beforeEnter: authGuard
    },
    {
      path: "/DonorAnalysis",
      name: "DonorAnalysis",
      component: DonorAnalysis,
      beforeEnter: authGuard
    },
    {
      path: "/DonorReport",
      name: "DonorReport",
      component: DonorReport,
      beforeEnter: authGuard
    }
  ]
});

export default router;